import { AddCircleOutline } from '@mui/icons-material';
import { AlertColor, Box, Button } from '@mui/material';
import strings from 'common/Translation/Translate';
import Notification from 'components/Notification';
import PageLoader from 'components/PageLoader';
import { useEffect, useState } from 'react';
import axiosInstance from 'utils/axios';
import { URLS } from 'utils/constants/urls';
import TimeslotRateMappingRow from './TimeslotRateMappingRow';

const TimeslotRateMapping = ({ timeslotRateMapping, setTimeslotRateMapping }: any) => {
  const [isLoading, seIstLoading] = useState(false);
  const [openForm, setOpenForm] = useState<boolean>(false);
  const [partOfDays, setPartOfDays] = useState<any[]>([]);
  const [message, setMessage] = useState<{
    display: boolean;
    severity: AlertColor | null;
    message: any;
  }>({
    display: false,
    severity: null,
    message: '',
  });

  useEffect(() => {
    const fetchPartOfDays = async () => {
      try {
        seIstLoading(true);
        const { data } = await axiosInstance.get(URLS.getPartOfDays);
        setPartOfDays(
          (data ?? []).map((item: any) => ({
            id: item.id,
            name: item.name,
          })),
        );
      } finally {
        seIstLoading(false);
      }
    };
    fetchPartOfDays();
  }, []);

  const closeNotification = (value: boolean) => {
    setMessage({ ...message, display: value });
  };

  return (
    <>
      {isLoading && <PageLoader />}
      {message.display && (
        <Notification
          isOpen={message.display}
          message={message.message}
          severity={message.severity as AlertColor}
          closeNotification={closeNotification}
        />
      )}
      <Box width={'100%'}>
        <Button
          data-testid="openForm_btn"
          onClick={() => setOpenForm(true)}
          variant="text"
          sx={{ '.MuiButton-endIcon': { marginLeft: '8px' }, minHeight: '36px', mb: 2, textTransform: 'capitalize' }}
          endIcon={<AddCircleOutline />}>
          {strings.addEditTimeslotRateMappings}
        </Button>
      </Box>
      {openForm && (
        <Box mb={2} width={'100%'}>
          <TimeslotRateMappingRow
            partOfDays={partOfDays}
            pageResponse={{
              partOfDay: '',
              rate: '',
            }}
            isAdd={true}
            setOpenForm={setOpenForm}
            timeslotRateMapping={timeslotRateMapping}
            setTimeslotRateMapping={setTimeslotRateMapping}
          />
        </Box>
      )}
      {timeslotRateMapping?.map((tsMapping: any) => (
        <TimeslotRateMappingRow
          id={tsMapping.partOfDay}
          key={tsMapping.partOfDay ?? tsMapping.id}
          partOfDays={partOfDays}
          pageResponse={tsMapping}
          isAdd={false}
          setOpenForm={setOpenForm}
          timeslotRateMapping={timeslotRateMapping}
          setTimeslotRateMapping={setTimeslotRateMapping}
        />
      ))}
    </>
  );
};
export default TimeslotRateMapping;
